import React from "react";
import { human } from "assets/img";

const SorryPage = () => (
  <div className="w-80 sorry-page">
    {/* Header with red background */}
    <div className="sorry-header-wrapper">
      <div className="sorry-header">
        <div className="sorry-header-content">
            この案件にはご参加いただく<br className="d-block d-md-none"/>ことができません
          <div className="sorry-character">
            <img src={human} alt="Sorry Character" />
          </div>
        </div>
      </div>

      {/* Main content with light pink background */}
      <div className="sorry-content">
        <div className="sorry-content-inner">
          <p className="sorry-intro">
            以下の条件に該当するため、ご参加いただくことができません。
          </p>
          
          <ul className="sorry-reasons">
            <li>すでにこのモニターに参加している</li>
            <li>1日の応募数に達してしまった</li>
            <li>モニター該当性別、年齢に当てはまっていない</li>
          </ul>
          
          <p className="sorry-conclusion">
            日をあけて再開する場合がございますので、<br/>ご希望の方は時間をおいて、再度ご確認いただけますと幸いです。
          </p>
        </div>
      </div>
    </div>
    <a href="/" className="btn-custom blue mt-5 d-flex justify-content-center mx-auto">TOP</a>
  </div>
);

export default SorryPage;
